import { useIsRegion, useLang } from './localisation';
import { useMemo } from 'react';
import { customerLogos } from 'define/customers';
import { germanRegion, usaRegion } from 'define/locale';

export const useCustomers = () => {
  const lang = useLang();
  const isUsaRegion = useIsRegion(usaRegion);
  const isGermanRegion = useIsRegion(germanRegion);

  const customers = useMemo(() => {
    if (lang === 'en' && isUsaRegion) {
      return customerLogos.us;
    }
    if (lang === 'en' && isGermanRegion) {
      return customerLogos.de;
    }

    return customerLogos[lang] ?? customerLogos.en;
  }, [lang, customerLogos, isUsaRegion, isGermanRegion]);

  return customers;
};
